
import { defineComponent, ref } from 'vue'

import TheHeading from './components/TheHeading.vue'
import SelectedRegexp from './components/SelectedRegexp.vue'
import LinkList from './components/LinkList.vue'
import FilterList from './components/FilterList.vue'

const JSON = './presets.json'

export default defineComponent({
  name: 'App',
  components: {
    TheHeading,
    LinkList,
    SelectedRegexp,
    FilterList
  },
  setup () {
    const filters = ref<Filter[]>([])

    fetch(JSON)
      .then((response) => response.json())
      .then((response) => {
        response.check = false
        filters.value = response.filters
      })
      .catch((error) => {
        alert('JSONの取得に失敗しました。時間をおいてやり直してください。')
        console.log(error)
      })

    const checked = ref<Filter[]>([])

    return {
      filters,
      checked
    }
  }

})
